import React, { useState, useEffect, useMemo } from "react";
import styles from "./proPlanTab.module.css";
import { Link } from "react-router-dom";
import { FaRupeeSign, FaMinus, FaPlus, FaLock, FaShieldAlt, FaRocket } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import {
    handlePaymentSuccesscontacts,
    createRazorpayOrderContacts,
    getStates,
    getUserInvoiceForm,
} from "../../Services/APIrequests";

const ProPlanTab = ({ data, redirect, creditType }) => {
    const navigate = useNavigate();
    const [creditCount, setCreditCount] = useState(10);
    const [showBillingModal, setShowBillingModal] = useState(false);
    const [statesList, setStatesList] = useState([]);
    const [fetchingBilling, setFetchingBilling] = useState(false);

    // Form state
    const [billingDetails, setBillingDetails] = useState({
        fullName: "",
        email: "",
        mobileNumber: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        pincode: "",
        GSTIN: "",
        invoiceType: "B2C", // Default value
    });

    useEffect(() => {
        // Pre-fill if needed, e.g., from session
        const name = sessionStorage.getItem("fullName") || "";
        const email = sessionStorage.getItem("email") || "";
        setBillingDetails(prev => ({
            ...prev,
            fullName: name,
            email: email,
        }));

        const fetchStates = async () => {
            try {
                const response = await getStates();
                setStatesList(response.data.states || []);
            } catch (error) {
                console.error("Error fetching states:", error);
            }
        };
        fetchStates();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setBillingDetails(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    // Find the tier that applies to the current credit count
    const activeTier = useMemo(() => {
        if (!data || data.length === 0) return null;
        const tier = data.find(tier => creditCount >= tier.minCredits && creditCount <= tier.maxCredits);
        if (tier) return tier;

        if (creditCount < data[0].minCredits) return data[0];
        return data[data.length - 1];
    }, [data, creditCount]);

    const handleCreditsChange = (value) => {
        const num = parseInt(value, 10);
        if (!isNaN(num)) {
            setCreditCount(num);
        } else if (value === "") {
            setCreditCount(0);
        }
    };

    const handleIncrement = () => setCreditCount(prev => prev + 1);
    const handleDecrement = () => setCreditCount(prev => (prev > 1 ? prev - 1 : prev));

    const handleSubscribe = async (
        razorpay_order_Id,
        razorpay_payment_id,
        credits,
        billingData
    ) => {
        try {
            const data2 = {
                razorpay_order_id: razorpay_order_Id,
                razorpay_payment_id: razorpay_payment_id,
                credits: credits,
                ...billingData,
            };

            const paymentCartDetailsApi1 = await handlePaymentSuccesscontacts(data2);

            if (paymentCartDetailsApi1.status === 200) {
                if (redirect) {
                    navigate(redirect);
                } else {
                    navigate("/SubscribeSuccessfully");
                }
            } else {
                alert(
                    paymentCartDetailsApi1.message ||
                    "Something went wrong while processing the subscription."
                );
            }
        } catch (error) {
            console.error("Error in handleSubscribe:", error);
            alert("An unexpected error occurred. Please try again.");
        }
    };

    const handlePayClick = async (e) => {
        e.preventDefault();
        if (!activeTier || creditCount === 0) return;
        setFetchingBilling(true);
        try {
            const invoiceRes = await getUserInvoiceForm().catch(() => null);
            if (invoiceRes?.data?.Status === 1 && invoiceRes.data.data) {
                const d = invoiceRes.data.data;
                setBillingDetails({
                    fullName: d.fullName || "",
                    email: d.email || "",
                    mobileNumber: d.mobileNumber || "",
                    address1: d.address1 || "",
                    address2: d.address2 || "",
                    city: d.city || "",
                    state: d.state || "",
                    pincode: d.pincode || "",
                    GSTIN: d.GSTIN || "",
                    invoiceType: d.invoiceType || "B2C",
                });
            }
        } catch (_) {}
        setFetchingBilling(false);
        setShowBillingModal(true);
    };

    const handleFinalPayment = async () => {
        if (!billingDetails.fullName || !billingDetails.email || !billingDetails.mobileNumber || !billingDetails.address1 || !billingDetails.city || !billingDetails.state || !billingDetails.pincode) {
            alert("Please fill in all required fields.");
            return;
        }

        try {
            const subtotal = creditCount * activeTier.pricePerCredit;
            const gstPercentage = 18;
            const gstAmount = subtotal * (gstPercentage / 100);
            const totalAmount = subtotal + gstAmount;
            const roundedAmount = parseFloat(totalAmount.toFixed(2));

            const paymentCartDetailsApi = await createRazorpayOrderContacts({
                amount: roundedAmount,
                type: creditType,
            });

            if (paymentCartDetailsApi.status === 201) {
                const billingData = {
                    ...billingDetails,
                    invoiceType: creditType,
                    credit: creditCount,
                    creditAmount: activeTier.pricePerCredit,
                    subtotal: subtotal,
                    totalamount: roundedAmount,
                    gstPercentage: gstPercentage,
                    gstAmount: gstAmount,
                };

                const options = {
                    key: process.env.REACT_APP_RAZORPAYKEY_TEST,
                    amount: roundedAmount * 100,
                    currency: "INR",
                    name: "Kohere",
                    description: "Order Payments",
                    order_id: paymentCartDetailsApi.data.data.razorpay_orderId,
                    handler: function (response) {
                        if (response.razorpay_payment_id !== null) {
                            handleSubscribe(
                                paymentCartDetailsApi.data.data.razorpay_orderId,
                                response.razorpay_payment_id,
                                creditCount,
                                billingData
                            );
                        } else {
                            alert("Something went wrong, please try again.");
                        }
                    },
                    prefill: {
                        name: billingDetails.fullName,
                        email: billingDetails.email,
                        contact: billingDetails.mobileNumber,
                    },
                    theme: {
                        color: "#1F66FF",
                    },
                };
                const rzp1 = new window.Razorpay(options);
                rzp1.open();
                setShowBillingModal(false);
            }
        } catch (error) {
            console.error("Error:", error);
            alert("An error occurred while processing the payment.");
        }
    };

    const subtotal = useMemo(() => {
        return (creditCount * (activeTier?.pricePerCredit || 0));
    }, [creditCount, activeTier]);

    const gst = useMemo(() => {
        const percentage = 0.18;
        return subtotal * percentage;
    }, [subtotal]);

    const totalAmount = useMemo(() => subtotal + gst, [subtotal, gst]);
    const gstPercentage = 18;

    const bundles = [
        { count: 10, popular: false },
        { count: 50, popular: true },
        { count: 99, popular: false },
    ];

    const getPriceForCount = (count) => {
        const tier = data.find(t => count >= t.minCredits && count <= t.maxCredits) || data[0];
        return tier?.pricePerCredit || 0;
    };

    return (
        <div className={styles.container}>
            {/* Left Column: Info Cards */}
            <div className={styles.leftColumn}>
                <div className={`${styles.card} ${styles.pricingTiers}`}>
                    <h2>Pricing Tiers</h2>
                    <p>Volume discounts apply automatically</p>
                    <div className={styles.tierList}>
                        <div className={styles.tierHeaders}>
                            <span>Tier</span>
                            <span>Price</span>
                        </div>
                        {data.map((tier) => (
                            <div key={tier.id} className={styles.tierRow}>
                                <div className={styles.tierInfo}>
                                    <span>{tier.minCredits} - {tier.maxCredits} credits</span>
                                    {tier.minCredits > 10 && <span className={styles.saveTag}>Save 12.5%</span>}
                                </div>
                                <div className={styles.pricePerCr}>
                                    ₹{tier.pricePerCredit} <span>/ cr</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className={`${styles.card} ${styles.howItWorks}`}>
                    <h2>How Credits Work</h2>
                    <div className={styles.creditsWorkRow}>
                        <span>Contact Data Access</span>
                        <div className={styles.creditValue}>
                            <span className={styles.creditCount}>1</span>
                            <span className={styles.creditLabel}>Credit per contact</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Middle Column: Selection */}
            <div className={styles.middleColumn}>
                <h2>Purchase Options</h2>
                <p>Select a bundle or enter a custom amount</p>

                <div className={styles.optionDivider}>
                    <span>Choose your own</span>
                </div>

                <div className={styles.customInputSection}>
                    <label>Number of Credits</label>
                    <div className={styles.inputStepper}>
                        <button type="button" className={styles.stepBtn} onClick={handleDecrement}><FaMinus /></button>
                        <input
                            type="number"
                            className={styles.creditsInput}
                            value={creditCount}
                            onChange={(e) => handleCreditsChange(e.target.value)}
                        />
                        <button type="button" className={styles.stepBtn} onClick={handleIncrement}><FaPlus /></button>
                    </div>
                </div>

                <div className={styles.optionDivider}>
                    <span>Or buy bundles</span>
                </div>

                <div className={styles.bundleList}>
                    {bundles.map((bundle) => {
                        const price = getPriceForCount(bundle.count);
                        const total = bundle.count * price;
                        return (
                            <div
                                key={bundle.count}
                                className={`${styles.bundleCard} ${creditCount === bundle.count ? styles.selected : ""}`}
                                onClick={() => setCreditCount(bundle.count)}
                            >
                                <div className={styles.bundleInfo}>
                                    <div className={styles.radioCircle}></div>
                                    <span className={styles.bundleTitle}>
                                        {bundle.count} Credits x ₹{price}
                                        {bundle.popular && <span className={styles.popularBadge}>Popular</span>}
                                    </span>
                                </div>
                                <span className={styles.bundlePrice}>₹{total.toLocaleString("en-IN")}</span>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* Right Column: Summary */}
            <div className={`${styles.card} ${styles.rightColumn}`}>
                <div className={styles.summaryHeader}>
                    <span>Credits</span>
                    <span className={styles.val}>{creditCount}</span>
                </div>
                <div className={styles.summaryHeader}>
                    <span>Price per Credit</span>
                    <span className={styles.val}>₹{activeTier?.pricePerCredit || 0}.00</span>
                </div>

                <div className={styles.summaryRow} style={{ marginTop: "32px" }}>
                    <span style={{ fontWeight: 700 }}>Subtotal</span>
                    <span style={{ fontWeight: 700 }}>₹{subtotal.toLocaleString("en-IN")}</span>
                </div>
                <div className={styles.summaryRow}>
                    <span>GST ({gstPercentage}%)</span>
                    <span>₹{Math.round(gst).toLocaleString("en-IN")}</span>
                </div>

                <div className={`${styles.summaryRow} ${styles.totalRow}`}>
                    <div className={styles.totalLabel}>
                        <span className={styles.totalMain}>Total Amount</span>
                        <span className={styles.totalTaxInfo}>(Including {gstPercentage}% GST)</span>
                    </div>
                    <div className={styles.totalAmount}>
                        <span className={styles.totalVal}>₹{Math.round(totalAmount).toLocaleString("en-IN")}</span>
                    </div>
                </div>

                <button
                    className={styles.buyBtn}
                    onClick={handlePayClick}
                    disabled={!activeTier || creditCount === 0 || fetchingBilling}
                >
                    {fetchingBilling ? (
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
                            <span style={{ width: 16, height: 16, border: "2px solid rgba(255,255,255,0.4)", borderTopColor: "#fff", borderRadius: "50%", display: "inline-block", animation: "spin 0.7s linear infinite" }} />
                            Loading...
                        </span>
                    ) : "Buy Now"}
                </button>

                <div className={styles.securityInfo}>
                    <div className={styles.securityItem}>
                        <FaLock className={styles.securityIcon} />
                        <span>Secure payment • No hidden fees</span>
                    </div>
                    <div className={`${styles.securityItem} ${styles.savings}`}>
                        <FaRocket className={styles.securityIcon} />
                        <span>Save more with larger packages</span>
                    </div>
                </div>
            </div>

            {/* Billing Modal */}
            {showBillingModal && (
                <div className={styles.modalOverlay}>
                    <div className={styles.modalContent}>
                        <div className={styles.modalHeader}>
                            <div>
                                <h2>Billing Details</h2>
                                <p>Enter your billing address for invoice generation</p>
                            </div>
                            <button className={styles.closeBtn} onClick={() => setShowBillingModal(false)}>&times;</button>
                        </div>
                        <div className={styles.modalBody}>
                            <div className={styles.formRow}>
                                <div className={styles.formGroup}>
                                    <label>Full Name *</label>
                                    <input type="text" name="fullName" value={billingDetails.fullName} onChange={handleInputChange} placeholder="John Doe" />
                                </div>
                                <div className={styles.formGroup}>
                                    <label>Email *</label>
                                    <input type="email" name="email" value={billingDetails.email} onChange={handleInputChange} placeholder="you@example.com" />
                                </div>
                            </div>
                            <div className={styles.formGroup}>
                                <label>Phone *</label>
                                <input type="text" name="mobileNumber" value={billingDetails.mobileNumber} onChange={handleInputChange} placeholder="+91 98765 43210" />
                            </div>
                            <div className={styles.formGroup}>
                                <label>Address Line 1 *</label>
                                <input type="text" name="address1" value={billingDetails.address1} onChange={handleInputChange} placeholder="Building / Street" />
                            </div>
                            <div className={styles.formGroup}>
                                <label>Address Line 2</label>
                                <input type="text" name="address2" value={billingDetails.address2} onChange={handleInputChange} placeholder="Landmark (optional)" />
                            </div>
                            <div className={styles.formRow}>
                                <div className={styles.formGroup}>
                                    <label>City *</label>
                                    <input type="text" name="city" value={billingDetails.city} onChange={handleInputChange} placeholder="Mumbai" />
                                </div>
                                <div className={styles.formGroup}>
                                    <label>State *</label>
                                    <select
                                        name="state"
                                        value={billingDetails.state}
                                        onChange={handleInputChange}
                                        className={styles.stateSelect}
                                    >
                                        <option value="">Select State</option>
                                        {statesList.map((st) => (
                                            <option key={st.stateId} value={st.stateName}>
                                                {st.stateName}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className={styles.formGroup}>
                                    <label>Pincode *</label>
                                    <input type="text" name="pincode" value={billingDetails.pincode} onChange={handleInputChange} placeholder="400001" />
                                </div>
                            </div>
                            <div className={styles.gstSection}>
                                <label>GSTIN (Optional)</label>
                                <input type="text" name="GSTIN" value={billingDetails.GSTIN} onChange={handleInputChange} placeholder="22AAAAA0000A1Z5" />
                                <p className={styles.gstNote}>Enter your GST number for a GST-compliant invoice</p>
                            </div>
                            <div className={styles.summarySection}>
                                <div className={styles.summaryLine}>
                                    <span>Credits</span>
                                    <span>{creditCount}</span>
                                </div>
                                <div className={styles.summaryLine}>
                                    <span>Subtotal</span>
                                    <span>₹{subtotal.toLocaleString("en-IN")}</span>
                                </div>
                                <div className={styles.summaryLine}>
                                    <span>GST ({gstPercentage}%)</span>
                                    <span>₹{Math.round(gst).toLocaleString("en-IN")}</span>
                                </div>
                                <div className={`${styles.summaryLine} ${styles.finalTotal}`}>
                                    <span>Total</span>
                                    <span className={styles.totalVal}>₹{Math.round(totalAmount).toLocaleString("en-IN")}</span>
                                </div>
                            </div>
                            <button className={styles.proceedBtn} onClick={handleFinalPayment}>
                                Proceed to Pay ₹{Math.round(totalAmount).toLocaleString("en-IN")}
                            </button>
                            <p className={styles.secureNote}>
                                <FaShieldAlt /> Secure payment • Invoice will be emailed
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProPlanTab;
